import { clearUser as clearSentryUser, setUser as setSentryUser } from '../sentry';
import type { ObservabilityUser } from '../types';

/**
 * Set the current user for error tracking
 * This attaches user information to all error reports
 */
export function setUser(user: ObservabilityUser): void {
  setSentryUser(user);
}

/**
 * Clear the current user context
 * Call this on logout
 */
export function clearUser(): void {
  clearSentryUser();
}

/**
 * Create user context from auth user object
 * Maps Commander auth user to observability user format
 */
export function createUserContext(authUser: {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  company_employee?: {
    company_id?: string;
    company?: {
      id?: string;
      name?: string;
    };
  } | null;
}): ObservabilityUser {
  const user: ObservabilityUser = {
    id: authUser.id,
    email: authUser.email,
  };

  // Add display name if available
  if (authUser.first_name || authUser.last_name) {
    user.username = [authUser.first_name, authUser.last_name].filter(Boolean).join(' ');
  }

  // Add company context if available
  if (authUser.company_employee?.company) {
    user.companyId = authUser.company_employee.company.id;
    user.companyName = authUser.company_employee.company.name;
  }

  return user;
}
